<template>
  <div class="button-container">
    <button :style="{ backgroundImage: getBackgroundImageValue(fileName), backgroundColor: backgroundColor }" />
  </div>
</template>

<script>
const getBackgroundImageValue = fileName => {
  return fileName ? `url('https://pointsmap.com/images/uploads/${fileName}')` : 'none'
}

export default {
  name: "HomeButton.vue",
  props: {
    fileName: String,
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  setup() {
    return {
      getBackgroundImageValue
    }
  },
}
</script>

<style scoped>
.button-container {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.button-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: v-bind('getBackgroundImageValue(fileName)');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  filter: blur(8px);
  z-index: 0;
}

button {
  position: relative;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  border: 1px solid #111;
  height: 100%;
  width: 100%;
  z-index: 1;
}
</style>
